export default __webpack_public_path__ + "static/media/logo.cd173128.png";